import { action } from 'mobx'
import storage from 'core/storage'
import * as constants from 'core/constants'
import Logger from 'core/jsLogger'
import store from '../store'

export default class Auth {

  @action
  setSession(params) {
    setSessionToken(params)
    store.token = params.token
    store.account = {type: params.accountType}
  }
}

// ---- Helpers
// Maybe they need their own directory?

export function getSessionToken() {
  try {
    return storage.get(constants.LOCALSTORAGE_SESSION_KEY, {})
  } catch (error) {
    return {}
  }
}

export function setSessionToken(params) {
  try {
    storage.set(constants.LOCALSTORAGE_SESSION_KEY, params)
  } catch (e) {
    Logger.error('Could not store auth data', e)
  }
}
